var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.033 0.797861C24.6557 1.35743 24.6557 2.26827 24.033 2.82785L9.84004 15.5839C9.2227 16.1387 8.22572 16.1387 7.60837 15.5839L0.96696 9.61491C0.344348 9.05533 0.344346 8.14449 0.96696 7.58492L1.39167 7.20321C2.00901 6.64836 3.006 6.64836 3.62333 7.20321L7.60837 10.7848C8.22572 11.3396 9.2227 11.3396 9.84004 10.7848L21.3766 0.416136C21.9939 -0.138712 22.9909 -0.138712 23.6083 0.416136L24.033 0.797861Z",
    fill: "#5DDEA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.d40add2614e17edc0dd84a5d3e23e83c.svg";
export { ForwardRef as ReactComponent };